import { Injectable } from '@angular/core';
import { of } from 'rxjs';

import { ClusterService } from '../../organisations/cluster.service';


@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(
    private cluster: ClusterService,
  ) { }

  public availableOrganisations() {
    return of(this.cluster.getCurrentOrganisations());
  }
}
